export default {
    status_no: '403',
    name: 'Odbijen',
    message: 'Zahtijev za ovaj resurs na serveru je odbijen',
}
